import { useEvent } from "./eventHooks";

export const useCommunitySubEvent = (communityId, eventId) => {
    const event = useEvent(communityId);
    return event?.subevents?.find(event => event.id == eventId);
};

